export default __webpack_public_path__ + "static/media/security-server3.9a740b72.png";